import phoneCodes from 'assets/phoneCodes.json'

/**
 * @param countryCode - country code
 * @returns phonecode
 */
export const getPhoneCodeByCountryCode = (countryCode: string) => {
  return phoneCodes.find(({ code }) => code === countryCode.toUpperCase())?.dialCode
}
